module.exports = __webpack_public_path__ + "img/gplay.5ec22422.svg";